import styled from 'styled-components';
import MaterialDialog from '@material-ui/core/Dialog';
import MaterialButton from '@material-ui/core/Button';
import MaterialDialogActions from '@material-ui/core/DialogActions';
import MaterialDialogContent from '@material-ui/core/DialogContent';
import MaterialFormHelperText from '@material-ui/core/FormHelperText';
import {
  AddShoppingCart as MaterialAddShoppingCart,
} from '../../styles/icons';
import CrudTable from '../crudTable';

export const Button = styled(MaterialButton)``;

export const Dialog = styled(MaterialDialog)``;

export const DialogActions = styled(MaterialDialogActions)``;

export const DialogContent = styled(MaterialDialogContent)`
  margin: 0px !important;
  padding: 0px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const AddShoppingCart = styled(MaterialAddShoppingCart)`
  width: 20px;
  height: 20px;
  fill: #808080;
`;

export const StyledCrudTable = styled(CrudTable)`
  margin-top: 10px;
  margin-bottom: 5px;
  width: 90%;
`;

